import {
  Autocomplete,
  Badge,
  Box,
  Button,
  Card,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Grid,
  InputLabel,
  styled,
  TextField,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import { ArrowBack, ArrowCircleLeftOutlined, ArrowCircleRightOutlined, ShoppingCart, Add, Remove, DeleteForever, ShoppingCartCheckout } from "@mui/icons-material";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import FsLightbox from "fslightbox-react";
import {

  IconButton,

} from "@mui/material";


function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const SchoolBox = styled("div")(({ theme }) => ({
  padding: "20px",
  border: "1px solid",
  borderRadius: "15px",
  background: "#fff",
  transition: "0.3s",
  cursor: "pointer",
  margin: "7px 7px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  "& img": {
    height: "100px",
    width: "100px",
    objectFit: "contain",
  },
  "&:hover": {
    color: "#888",
    background: "#1976d2",
    border: "1px solid #1976d2",
  },
}));


//////////////////////////////////////////////////////////



const ItemsBox = styled(Box)(({ theme }) => ({
  minWidth: "1200px",
  borderBottom: "1px solid #999",
  padding: "10px 0px",
  display: "flex",
  alignItems: "center",
  justifyContent: "left",
}));
const ItemsBox1 = styled(Box)(({ theme }) => ({
  minWidth: "800px",
  borderBottom: "1px solid #999",
  padding: "10px 0px",
  display: "flex",
  alignItems: "center",
  justifyContent: "left",
}));


const ImageBox = styled(Box)(({ theme }) => ({
  marginRight: "20px",
  "& img": {
    width: "100px",
    height: "80px",
    objectFit: "contain",
    borderRadius: "10px",
  },
}));

const ProductCode = styled(Box)(({ theme }) => ({
  width: "120px",
  // marign: "0 10px",
}));

const ProductName = styled(Box)(({ theme }) => ({
  width: "310px",
  marign: "0 10px",
}));

const ProductName1 = styled(Box)(({ theme }) => ({
  width: "410px",
  // marign: "0 10px",
}));

const Cart = styled(Box)(({ theme }) => ({
  width: "610px",
  color: "#999",
  // marign: "0 10px",
}));

const ProductColor = styled(Box)(({ theme }) => ({
  width: "240px",
  color: "#999",
  // marign: "0 10px",
}));

const ProductPrice = styled(Box)(({ theme }) => ({
  width: "120px",
  // marign: "0 10px",
}));

const ProductPrice1 = styled(Box)(({ theme }) => ({
  width: "200px",
}));

const ProductLocation = styled(Box)(({ theme }) => ({
  width: "100px",
  color: "#999",
  // marign: "0 10px",
}));

const QuantityBox = styled(Box)(({ theme }) => ({

  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

// const ButtonDiv = styled(Box)(({ theme }) => ({
//   marginLeft: "50px",
//   textAlign: "left",
//   width: "150px",
// }));

const ButtonDiv = styled(Box)(({ theme }) => ({
  marginLeft: "0px",
  textAlign: "right",
  width: "175px",
}));

////////////////////////////////////////////////////////

const SelectSchool = ({
  step,
  setStep,
  customerDetails,
  // schoolList,
  handleChange,
  handleClickSchool,
  handleClickSchool1,
  handleChangeSchool,
  handleSubstract,
  handleAdd,
  handleQuantity,
  handleRemoveFromCart,
  state,
  setState,
}) => {
  const [value, setValue] = useState(0);
  const [schoolIDs, setSchoolIDs] = useState([]);
  const [schoollistResume, setSchoollistResume] = useState([]);
  const [cartOpen, setCartOpen] = useState(false);

  const [toggler1, setToggler1] = useState(false);
  const [imageIndex1, setImageIndex1] = useState(0);

  const handleCartImageShow = (index) => {
    setToggler1(!toggler1);
    setImageIndex1(index);
  };

  const handleChangeTabs = (event, newValue) => {
    setValue(newValue);
  };
  const schoolList1 = localStorage.getItem("school-list");
  const schoolList = JSON.parse(schoolList1);
  //console.log("school-list", schoolList);

  // let schoolList;


  // if (customerDetails.type === "resume") {
  //   console.log("schoolIDs", customerDetails.schoolID1);
  //   const schoolIDs = customerDetails.schoolID1.split(',');
  //   console.log("schoolIDs11", schoolIDs);

  //   const schoollistResume = schoolList.filter(school => schoolIDs.includes(school.SchoolID));

  //   console.log("schoollistresume11", schoollistResume);
  //   setSchoollistResume(schoollistResume); 

  // } 

  // console.log("schoollistresume1133333", schoollistResume);
  useEffect(() => {
    if (customerDetails.type === "resume") {
      //console.log("schoolIDs", customerDetails.schoolID1);
      const schoolIDs = customerDetails.schoolID1?.split(',');
      //console.log("schoolIDs11", schoolIDs);

      const schoollistResume = schoolList.filter(school => schoolIDs?.includes(school.SchoolID));

      //console.log("schoollistresume11", schoollistResume);
      setSchoollistResume(schoollistResume);
    }
  }, []);

  useEffect(() => {
    setState("");
  }, []);


  const handleImageError = (e) => {
    e.target.onerror = null;
    e.target.src = "https://www.psw.com.au/media/catalog/product/placeholder/default/Image-Coming-Soon.png";
  }

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [currentChunkIndex, setCurrentChunkIndex] = useState(0);

  const handleNextSlide = () => {
    setCurrentChunkIndex((currentChunkIndex + 1) % chunkedSchoolList.length);
  };

  const handlePrevSlide = () => {
    const newIndex = currentChunkIndex - 1;
    if (newIndex >= 0) {
      setCurrentChunkIndex(newIndex);
    }
  };

  const chunkedSchoolList = [];
  const chunkSize = 25;
  for (let i = 0; i < schoolList.length; i += chunkSize) {
    const chunk = schoolList.slice(i, i + chunkSize);
    chunkedSchoolList.push(chunk);
  }

  const placeholderImageUrl = 'https://www.psw.com.au/media/catalog/product/placeholder/default/Image-Coming-Soon.png';


  const cartImageUrls = customerDetails.cartItems.map((cart) => {
    if (cart.imageUrl) {
      return cart.imageUrl;
    } else {
      return placeholderImageUrl;
    }
  });

  return (
    <Card>
      <Box p={4}>
        <Box mb={3}
          //  textAlign="center"
          display="flex"
          alignItems={"center"}
          justifyContent="space-between"
        >
          <h2>School</h2>
          {customerDetails.type === "resume" && (
            <h4>
              Cart{" "}
              <Badge
                badgeContent={customerDetails.cartItems.length}
                color="secondary"
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
              >
                <ShoppingCart sx={{ cursor: "pointer" }} onClick={() => setCartOpen(true)} />
              </Badge>
            </h4>
          )}
        </Box>
        <Grid container spacing={2}>
          <Box sx={{ bgcolor: "#fcfcfc", width: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                orientation={isMobile ? 'vertical' : 'horizontal'}
                value={value}
                onChange={handleChangeTabs}
                aria-label="selct_tabs"
              >
                {customerDetails.type === "resume" ? (
                  <Tab label="Schools In Cart" {...a11yProps(0)} />
                ) : (
                  <Tab label="Select School" {...a11yProps(0)} />

                )}
                {customerDetails.type === "resume" ? (
                  <Tab label="Select School" {...a11yProps(1)} />
                ) : (
                  <Tab label="Search School" {...a11yProps(1)} />

                )}
                {customerDetails.type === "resume" &&
                  <Tab label="Search School" {...a11yProps(2)} />
                }

              </Tabs>
            </Box>
            {customerDetails.type === "resume" ? (

              <TabPanel value={value} index={0}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <div>

                    <FormControl component="fieldset">
                      <FormLabel style={{ marginBottom: "10px", width: "100%", display: "flex", justifyContent: "flex-end" }}>


                      </FormLabel>

                      <FormGroup aria-label="position" row>

                        {schoollistResume && schoollistResume.map((school, index) => (
                          <SchoolBox
                            style={{
                              background: school.SchoolName === customerDetails.school ? "#1976d2" : "#fff",
                              color: school.SchoolName === customerDetails.school ? "#fff" : "#888",

                            }}
                            onClick={() => handleClickSchool(school.SchoolName, school.SchoolID)}
                          >
                            {school.SchoolName}
                          </SchoolBox>

                        ))}




                      </FormGroup>
                    </FormControl>
                  </div>
                  <div>
                    <Button
                      style={{
                        borderRadius: "15px",
                        transition: "0.3s",
                        cursor: "pointer",
                        margin: "7px 7px",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      variant="contained"
                      size="large"
                      color="secondary"
                      onClick={() => handleClickSchool1()}
                    //onClick={() => setStep(step + 1)}

                    >
                      Cart Products <ShoppingCart fontSize="medium" sx={{ margin: "10px" }} />
                    </Button>
                  </div>
                </div>
              </TabPanel>
            ) : (
              <TabPanel value={value} index={0}>
                <FormControl component="fieldset">
                  <FormLabel style={{ marginBottom: "10px" }}>
                    Schools
                    {customerDetails.type !== "resume" && schoolList.length > 25 &&
                      <>
                        <div style={{ display: "flex", alignItems: "center", float: 'right' }}>
                          <span></span>
                          <ArrowCircleRightOutlined
                            onClick={handleNextSlide}
                            sx={{ display: "flex", cursor: "pointer", marginLeft: "5px" }}
                          />
                        </div>

                        <div style={{ display: "flex", alignItems: "center", float: 'right' }}>
                          <ArrowCircleLeftOutlined
                            onClick={handlePrevSlide}
                            sx={{ display: "flex", cursor: "pointer", marginRight: "5px" }}

                          />
                          <span></span>&nbsp;&nbsp;<span></span>&nbsp;&nbsp;
                        </div>
                      </>
                    }
                  </FormLabel>
                  <FormGroup aria-label="position" row>

                    {chunkedSchoolList ? chunkedSchoolList[currentChunkIndex]?.map((school, index) => (
                      <SchoolBox
                        style={{
                          background: school.SchoolName === customerDetails.school ? "#1976d2" : "#fff",
                          color: school.SchoolName === customerDetails.school ? "#fff" : "#888",

                        }}
                        onClick={() => handleClickSchool(school.SchoolName, school.SchoolID)}
                      >
                        {school.SchoolName}
                      </SchoolBox>

                    )) : null}
                  </FormGroup>
                </FormControl>
              </TabPanel>

            )}

            {customerDetails.type === "resume" ? (
              <TabPanel value={value} index={1}>
                <FormControl component="fieldset">
                  <FormLabel style={{ marginBottom: "10px" }}>
                    {schoolList.length > 25 &&
                      <>

                        <div style={{ display: "flex", alignItems: "center", float: 'right' }}>
                          <span></span>
                          <ArrowCircleRightOutlined
                            onClick={handleNextSlide}
                            sx={{ display: "flex", cursor: "pointer", marginLeft: "5px" }}
                          />
                        </div>

                        <div style={{ display: "flex", alignItems: "center", float: 'right' }}>
                          <ArrowCircleLeftOutlined
                            onClick={handlePrevSlide}
                            sx={{ display: "flex", cursor: "pointer", marginRight: "5px" }}

                          />
                          <span></span>&nbsp;&nbsp;<span></span>&nbsp;&nbsp;
                        </div>

                      </>
                    }

                  </FormLabel>
                  <FormGroup aria-label="position" row>
                    {chunkedSchoolList && chunkedSchoolList[currentChunkIndex].map((school, index) => (
                      <SchoolBox
                        style={{
                          background: school.SchoolName === customerDetails.school ? "#1976d2" : "#fff",
                          color: school.SchoolName === customerDetails.school ? "#fff" : "#888",

                        }}
                        onClick={() => handleClickSchool(school.SchoolName, school.SchoolID)}
                      >
                        {school.SchoolName}
                      </SchoolBox>

                    ))}
                  </FormGroup>
                </FormControl>
              </TabPanel>
            ) : (
              <TabPanel value={value} index={1}>
                <InputLabel>School</InputLabel>
                <Autocomplete
                  sx={{ background: "#fff" }}
                  disablePortal
                  id="school"
                  options={schoolList}
                  onChange={(event, newValue) => {
                    handleChangeSchool(newValue);
                  }}
                  inputValue={customerDetails.school}
                  // sx={{ width: 300 }}
                  getOptionLabel={(option) => option.SchoolName}
                  renderOption={(props, option) => (
                    <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>
                      {option.SchoolName}
                    </Box>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      onChange={handleChange}
                      value={customerDetails.school}
                      variant="outlined"
                      name="school"
                    // label="School"
                    />
                  )}
                />
              </TabPanel>

            )}

            {customerDetails.type === "resume" &&
              <TabPanel value={value} index={2}>
                <InputLabel>School</InputLabel>
                <Autocomplete
                  sx={{ background: "#fff" }}
                  disablePortal
                  id="school"
                  options={schoolList}
                  onChange={(event, newValue) => {
                    handleChangeSchool(newValue);
                  }}
                  inputValue={customerDetails.school}
                  // sx={{ width: 300 }}
                  getOptionLabel={(option) => option.SchoolName}
                  renderOption={(props, option) => (
                    <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>
                      {option.SchoolName}
                    </Box>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      onChange={handleChange}
                      value={customerDetails.school}
                      variant="outlined"
                      name="school"
                    // label="School"
                    />
                  )}
                />
              </TabPanel>
            }
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Box textAlign={value === 1 ? "center" : "left"} display="flex" alignItems={"center"} justifyContent="space-between" mt={3}>
            <Button
              variant="contained"
              size="large"
              color="secondary"
              onClick={() => setStep(step - 2)}
              style={{ marginRight: "10px" }}
            >
              <ArrowBack fontSize="small" sx={{ marginRight: "5px" }} /> Back
            </Button>

            {((customerDetails.type !== "resume" && value === 1) || (customerDetails.type === "resume" && value === 2)) &&
              <Button
                variant="contained"
                size="large"
                color="primary"
                onClick={() => setStep(step + 1)}
                disabled={!customerDetails.school}
              >
                Next
              </Button>
            }
          </Box>
        </Grid>
        <Dialog open={cartOpen} onClose={() => setCartOpen(false)} style={{ minWidth: '800px !important' }} maxWidth="xl">
          <DialogTitle>
            <Box mb={3} textAlign="center">
              <h3>Cart Items</h3>
            </Box>
          </DialogTitle>
          <DialogContent>
            <FsLightbox
              toggler={toggler1}
              sources={cartImageUrls}
              sourceIndex={imageIndex1}
              type="image"
            />

            <div>
              {customerDetails.cartItems.length === 0 ? (
                <Cart>Your cart is empty</Cart>
              ) : (
                <ul>
                  {customerDetails.cartItems.map((cart, index) => (
                    <ItemsBox1 key={cart.id}>
                      <ImageBox onClick={() => handleCartImageShow(index)}>
                        {cart.imageUrl ? (
                          <img
                            src={cart.imageUrl}
                            alt={cart.ItemName}
                            onError={handleImageError}
                          />
                        ) : (
                          <img
                            src="https://www.psw.com.au/media/catalog/product/placeholder/default/Image-Coming-Soon.png"
                            alt="Placeholder"
                          />
                        )}
                      </ImageBox>
                      <ProductName1><b>{cart.ItemName}</b></ProductName1>
                      <ProductColor>{cart.ColourName.replace(/_/g, ' ').replace(/\//g, ' ')}</ProductColor>
                      <ProductCode>{cart.SizeID}</ProductCode>
                      <ProductPrice>${cart.RetailSalesPrice}</ProductPrice>
                      <QuantityBox>
                        {!cart.options && (
                          <>
                            <IconButton onClick={() => handleSubstract(cart.id)}>
                              <Remove />
                            </IconButton>
                            <TextField
                              name="quantity"
                              type="number"
                              variant="outlined"
                              value={
                                (customerDetails.quantity[cart.id] === 0
                                  ? 0
                                  : customerDetails.quantity[cart.id]) || 1
                              }
                              onChange={(e) => handleQuantity(e, cart.id)}
                              style={{ width: '100px' }}
                            />
                            <IconButton onClick={() => handleAdd(cart.id)}>
                              <Add />
                            </IconButton>
                          </>
                        )}
                      </QuantityBox>
                      <ProductPrice1>
                        Total: ${(parseFloat(cart.RetailSalesPrice) * (parseFloat(customerDetails.quantity[cart.id]) || 1)).toFixed(2)}
                      </ProductPrice1>
                      <DeleteForever
                        sx={{ fontSize: '30px' }}
                        color="secondary"
                        variant="contained"
                        cursor="pointer"
                        onClick={() => handleRemoveFromCart(cart.id)}
                      />
                    </ItemsBox1>
                  ))}
                  <ProductPrice1 sx={{ display: 'flex', float: 'right' }}>
                    Sum Total: $
                    {(
                      customerDetails.cartItems.reduce((total, cart) => total + parseFloat(cart.RetailSalesPrice) * (parseFloat(customerDetails.quantity[cart.id]) || 1), 0) 
                      // (customerDetails.cartItems.reduce((total, cart) => total + parseFloat(cart.RetailSalesPrice) * (parseFloat(customerDetails.quantity[cart.id]) || 1), 0) * 0.10)
                    ).toFixed(2)}
                  </ProductPrice1>

                </ul>
              )}
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setCartOpen(false)}>Close</Button>
          </DialogActions>
        </Dialog>
      </Box>

    </Card>
  );
};

export default SelectSchool;
